export const CHEATSHEET_BLOCKS = [
    {
        type: "heading",
        label: "Heading"
    },
    {
        type: "text",
        label: "Text"
    },
    {
        type: "image",
        label: "Image"
    },
    {
        type: "code",
        label: "Code"
    },
    {
        type: "list",
        label: "List"
    },
    {
        type: "info",
        label: "Info"
    },
    {
        type: "warning",
        label: "Warning"
    }
];